import { useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import { TextField, Checkbox, Chip } from "../../../common/VFX-UI";
import ActionBar from "../../../common/ActionBar/ActionBar";
import FormBackGround from "../../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../../common/Forms/FormHeader/FormHeader";

//App
import { LookupTypeFormProps } from "../../../../types/lookupType";
import { EMPTY_GUID } from "../../../../utility/constants";
import { Container } from "reactstrap";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  sortValue: Yup.number().min(0, "Must be positive number"),
});

const LookupTypeForm = (props: LookupTypeFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);

  const { id } = initialVal;
  const title = id === EMPTY_GUID ? "New Lookup Type" : "Edit Lookup Type";

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Container>
            <Form noValidate>
              <div className="d-flex justify-content-end mb-3 me-3">
                <Chip label={values.isActive ? "Active" : "Inactive"} />
              </div>
              <TextField
                label="Name"
                type="text"
                name="name"
                isRequired={true}
              />
              <TextField
                label="Description"
                type="textarea"
                name="description"
                isRequired={true}
              />
              <TextField label="Display Order" type="number" name="sortValue" />
              <Checkbox label="Is Grouped" name="isGrouped" />
              <ActionBar
                submitHandler={saveInput}
                cancelHandler={onClose}
                submitText="Submit"
                cancelText="Cancel"
                isLoading={status === "pending"}
              ></ActionBar>
            </Form>
          </Container>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default LookupTypeForm;
